import { createRouter, createWebHashHistory } from "vue-router";
import blogRoute from "@/router/blog";
import routes from "@/router/app";
import releaseRoute from "@/router/release";

routes.push(blogRoute);
routes.push(releaseRoute)
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
